import { FormattedMessage, useIntl } from 'react-intl'
import { type DialogState } from 'ariakit'
import { csx, ModalContent, Paragraph } from '@vtex/admin-ui'
import { CustomModal } from '@/components/CustomModal'
import { localeNumber } from '@/lib/resolveLocale'

export type ExportModalMessagesProps = {
  limitModal: DialogState
  exportLimit: number
}

export const ExportModalMessages = ({
  limitModal,
  exportLimit,
}: ExportModalMessagesProps) => {
  const { formatMessage, locale } = useIntl()

  return (
    <CustomModal
      title={formatMessage({
        id: 'admin/admin.catalog.export-limit-modal.title',
        defaultMessage: 'Export limit reached',
      })}
      state={limitModal}
      size="small"
    >
      <ModalContent
        className={csx({
          paddingTop: '0',
        })}
      >
        <Paragraph>
          <FormattedMessage
            id="admin/admin.catalog.export-limit-modal.message"
            defaultMessage={`Your export exceeds {exportLimit} products. To continue, reduce the number of items using search or filters and try again.`}
            values={{ exportLimit: localeNumber(exportLimit, locale) }}
          />
        </Paragraph>
      </ModalContent>
    </CustomModal>
  )
}
